



















































































































































































































































































































































































































































import _ from "lodash";
import rest from "@/rest";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Action, namespace } from "vuex-class";
import { vuex } from "@/store";
import router from "@/router";
import { PortalUserVM, SelectListItem, GroupVm } from "@/interfaces/PortalUserVM";
import { ExerciseVM } from "../interfaces/ExerciseVM";
import ExStatus from "../components/ExerciseComponents/ExStatus.vue";
import { ExBundleAssignmentVM, ExBundleVM } from "@/interfaces/ExBundleAssignmentVM";
import moment from "moment";
import { ParamDictionary } from "@/interfaces/ParamDictionary";

// import VueQrcode from "@chenfengyuan/vue-qrcode"; // https://github.com/fengyuanchen/vue-qrcode

const globals = namespace("globals");
const auth = namespace("auth");

@Component({
  components: {
    ExStatus
  }
})
export default class ExerciseBundleView extends Vue {
  @globals.Getter selectedExBundleAssignment!: ExBundleAssignmentVM;
  @globals.Getter selectedLanguageCode!: string | null;
  @globals.Getter selectedGroup!: GroupVm;
  // @globals.Getter selectedUser!: PortalUserVM;
  @auth.Getter isAdmin: any;
  @auth.Getter isGroupAdmin: any;
  // @auth.Getter isParent: any;
  // @auth.Getter isPupil: any;

  exercises: ExerciseVM[] = [];

  // breadcrumbItems = [
  //   { text: "Start", disabled: false, href: "/home" },
  //   { text: "Schulungen", disabled: false, href: "/exercises" },
  //   { text: "Schulungspäckchen", disabled: true, href: "/exerciseBundle" }
  // ];

  // breadcrumbItemsFromCatalog = [
  //   { text: "Start", disabled: false, href: "/home" },
  //   { text: 'Schulungen', disabled: false, href: '/exercises' },
  //   // { text: "Schulungskatalog", disabled: false, href: "/exerciseCatalog" },
  //   { text: "Schulungspäckchen", disabled: true, href: "/exerciseBundle" }
  // ];

  async mounted() {
    if (this.selectedExBundleAssignment == null) {
      router.push("/");
      return;
    }

    // If this.selectedLanguageCode is not included in availableLanguages, initialize selected language to bundle master language
    if (!this.selectedLanguageCode || !this.availableLanguages.includes(this.selectedLanguageCode)) {
      this.$nextTick(async () => {
        const bundle = this.selectedExBundleAssignment?.exBundle;
        const defaultLang = bundle?.masterLanguageCode || this.availableLanguages[0] || "de-DE";
        await vuex.globals.setSelectedLanguageCode(defaultLang);
      });
    }

    await this.updateView();

    // Focus first exercise after data is loaded
    this.$nextTick(() => {
      this.focusFirstExercise();
    });

    vuex.quizplayerstore.saveCurrentRouteName();
  }

  get availableLanguages(): string[] {
    const bundle = this.selectedExBundleAssignment?.exBundle;
    if (!bundle) return [];
    const codes = bundle.translationLanguageCodes ? [...bundle.translationLanguageCodes] : [];
    if (bundle.masterLanguageCode && !codes.includes(bundle.masterLanguageCode))
      codes.unshift(bundle.masterLanguageCode);
    return codes;
  }

  getLanguageText(code: string) {
    if (!code) return "";
    const lang = (this.$globalHelper.euLanguageOptions || []).find((l: any) => l.value === code);
    return lang ? lang.text : code;
  }

  getTranslatedModuleName(item: ExerciseVM): string {
    const names = (item as ExerciseVM).nameTranslations as Record<string,string> | undefined;
    const code = this.selectedLanguageCode || "de-DE";
    if (names && names[code] && names[code].length > 0) {
      return names[code];
    }
    return item.name || '';
  }

  getTranslatedBundleName(): string {
    const names = (this.selectedExBundleAssignment.exBundle as ExBundleVM).nameTranslations as Record<string,string> | undefined;
    const code = this.selectedLanguageCode || "de-DE";
    if (names && names[code] && names[code].length > 0) {
      return names[code];
    }
    return this.selectedExBundleAssignment.exBundle?.name || '';
  }

  getFlagUrlForLanguage(code: string) {
    if (!code) return "";
    const lang = (this.$globalHelper.euLanguageOptions || []).find((l: any) => l.value === code);
    if (lang && lang.countryCode)
      return this.$globalHelper.getFlagUrl(lang.countryCode);
    return "";
  }

  async selectLanguage(code: string) {
    if (!code) return;
    // this.selectedLanguageCode = code;
    await vuex.globals.setSelectedLanguageCode(code);
    await this.getExercises();
  }

  async updateView() {
    await this.$globalHelper.delay(50); // Wait until Scorm data is written to backend
    await this.updateExBundleAssignment();
    await this.getExercises();
  }

  handleKeyNavigation(event: KeyboardEvent, currentIndex: number) {
    if (!this.exercises || this.exercises.length === 0) {
      return;
    }

    let targetIndex = -1;

    switch (event.key) {
      case 'ArrowDown':
      case 'ArrowRight':
        event.preventDefault();
        event.stopPropagation();
        targetIndex = currentIndex + 1;
        if (targetIndex >= this.exercises.length) {
          targetIndex = 0; // Wrap to first item
        }
        break;

      case 'ArrowUp':
      case 'ArrowLeft':
        event.preventDefault();
        event.stopPropagation();
        targetIndex = currentIndex - 1;
        if (targetIndex < 0) {
          targetIndex = this.exercises.length - 1; // Wrap to last item
        }
        break;

      case 'Home':
        event.preventDefault();
        event.stopPropagation();
        targetIndex = 0;
        break;

      case 'End':
        event.preventDefault();
        event.stopPropagation();
        targetIndex = this.exercises.length - 1;
        break;

      default:
        return; // Don't handle other keys
    }

    // Focus the target item
    this.focusExerciseItem(targetIndex);
  }

  focusExerciseItem(index: number) {
    this.$nextTick(() => {
      const listItems = document.querySelectorAll('.exercise-list-item');
      if (listItems[index]) {
        (listItems[index] as HTMLElement).focus();

        // Announce the current position for screen readers
        const currentExercise = this.exercises![index];
        const exerciseName = currentExercise?.name || 'Unbekannte Übung';
        const exerciseType = this.getIconAriaLabel(currentExercise?.type || '');
        this.announceToScreenReader(`${exerciseName} (${exerciseType}), Position ${index + 1} von ${this.exercises!.length}`);
      }
    });
  }

  focusFirstExercise() {
    // Wait a bit more to ensure DOM is fully rendered
    setTimeout(() => {
      if (this.exercises && this.exercises.length > 0) {
        // Use CSS selector to find the first exercise
        const firstExerciseElement = document.querySelector('.first-exercise-item') as HTMLElement;

        if (firstExerciseElement && typeof firstExerciseElement.focus === 'function') {
          firstExerciseElement.focus();
          // Announce to screen reader
          const firstExercise = this.exercises[0];
          const exerciseName = firstExercise?.name || 'Erste Übung';
          const exerciseType = this.getIconAriaLabel(firstExercise?.type || '');
          this.announceToScreenReader(`${this.exercises.length} Übungen geladen. Erste Übung "${exerciseName}" (${exerciseType}) ist fokussiert.`);
        } else {
          // Fallback: try to find any exercise item
          const anyExerciseElement = document.querySelector('.exercise-list-item') as HTMLElement;
          if (anyExerciseElement && typeof anyExerciseElement.focus === 'function') {
            anyExerciseElement.focus();
            this.announceToScreenReader(`${this.exercises.length} Übungen geladen. Erste Übung ist fokussiert.`);
          } else {
            this.announceToScreenReader(`${this.exercises.length} Übungen geladen.`);
          }
        }
      } else {
        // If no exercises available, announce this
        this.announceToScreenReader('Keine Übungen verfügbar.');
      }
    }, 200); // Increased timeout to ensure Vue components are fully rendered
  }

  announceToScreenReader(message: string) {
    // Create or update live region for announcements
    let announcement = document.getElementById('exercise-page-announcements');
    if (!announcement) {
      announcement = document.createElement('div');
      announcement.id = 'exercise-page-announcements';
      announcement.setAttribute('aria-live', 'polite');
      announcement.setAttribute('aria-atomic', 'true');
      announcement.className = 'sr-only';
      document.body.appendChild(announcement);
    }

    announcement.textContent = message;
    // Clear after announcement
    setTimeout(() => {
      announcement!.textContent = '';
    }, 1000);
  }

  async getExercises() {
    let params: ParamDictionary = { dictionary: {} };
    params.dictionary!["UserId"] = this.selectedExBundleAssignment.userId!;
    params.dictionary!["BundleId"] = this.selectedExBundleAssignment.exBundle?.id.toString() ?? "0";
    params.dictionary!["BundleAssignmentId"] = this.selectedExBundleAssignment.id.toString();
    // params.dictionary!["GroupId"] = this.selectedExBundleAssignment.groupId.toString()
    params.dictionary!["Enabled"] = this.selectedExBundleAssignment.enabled ? "true" : "false";
    params.dictionary!["LanguageCode"] = this.selectedLanguageCode ?? "de-DE";

    this.exercises = await rest
      .url("exercises/getExercises")
      // .post(this.selectedExBundleAssignment);
      .post(params);
  }

  async updateExBundleAssignment() {
    if (this.selectedExBundleAssignment.id == 0 || !this.selectedExBundleAssignment.userId)
      return;

    let exBundle = await rest
      .url("exercises/updateExBundleAssignment")
      .post(this.selectedExBundleAssignment);
      this.$store.commit('globals/setExBundleAssignment', exBundle);
  }

  startExercise(exercise: ExerciseVM) {
    if (!exercise.enabled || exercise.locked)
      return;

    // Check if we're already on the exercise route to prevent redundant navigation
    if (this.$route.name === 'exercise' || this.$route.path === '/exercise') {
      return;
    }

    this.$store.commit("globals/setExercise", exercise);

    // Use router.push with error handling
    router.push("/exercise").catch(err => {
      // Ignore navigation duplicated error
      if (err.name !== 'NavigationDuplicated') {
        console.error('Navigation error:', err);
      }
    });
  }

  onLoadPdf() {
    let params: ParamDictionary = { dictionary: {} };
    params.dictionary!["UserId"] = this.selectedExBundleAssignment.userId!;
    params.dictionary!["BundleId"] = this.selectedExBundleAssignment.exBundle?.id.toString() ?? "0";
    params.dictionary!["GroupId"] = this.selectedExBundleAssignment.groupId.toString() ?? "0";
    params.dictionary!["PdfFileName"] = "";

    this.$globalHelper.blobDownloadWithAuth("api/exercises/loadSingleCertificatePdf", `${this.selectedExBundleAssignment.user?.firstName} ${this.selectedExBundleAssignment.user?.lastName}-${this.selectedExBundleAssignment.exBundle?.name}-Zertifikat.pdf`, params);
  }

  finishedDateToLocal(finishedDate: string) {
    if (!finishedDate)
      return "";

    // let date = moment(finishedDate).toDate().toLocaleString([], {year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit'});
    let date = moment(finishedDate).toDate().toLocaleString([], {year: 'numeric', month:  '2-digit', day: '2-digit'});
    return " | " + date;
  }

  dateToLocal(date: string) {
    if (!date)
      return "";

    // let date = moment(finishedDate).toDate().toLocaleString([], {year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit'});
    let dateFormated = moment(date).toDate().toLocaleString([], {year: 'numeric', month:  '2-digit', day: '2-digit'});
    return dateFormated;
  }

  goBack() {
    router.go(-1);
  }

  // Accessibility computed properties and methods
  get avatarAriaLabel() {
    return `Bild für ${this.selectedExBundleAssignment?.exBundle?.name || 'Übungspaket'}`;
  }

  get categoryAriaLabel() {
    const bundle = this.selectedExBundleAssignment?.exBundle;
    if (!bundle) return 'Kategorie nicht verfügbar';
    return `Kategorie: ${bundle.category1 || ''}, ${bundle.category2 || ''}, ${bundle.category3 || ''}`;
  }

  get approvalAriaLabel() {
    const adminName = this.selectedExBundleAssignment?.finishedByAdminName || 'Unbekannt';
    const date = this.selectedExBundleAssignment?.finishedByAdminDate;
    return `Freigabe erteilt durch ${adminName} am ${date ? this.dateToLocal(date.toString()) : 'Unbekannt'}`;
  }

  get certificateAriaLabel() {
    const date = this.selectedExBundleAssignment?.certificateClosingDate;
    return `Zertifikat erteilt am ${date ? this.dateToLocal(date.toString()) : 'Unbekannt'}`;
  }

  getExerciseAriaLabel(item: ExerciseVM) {
    const typeLabel = this.getIconAriaLabel(item.type || '');
    const statusLabel = this.getStatusAriaLabel(item);
    const enabledLabel = item.enabled ? 'verfügbar' : 'nicht verfügbar';
    return `${typeLabel}: ${item.name}, Status: ${statusLabel}, ${enabledLabel}`;
  }

  getIconAriaLabel(type: string) {
    const typeLabels: { [key: string]: string } = {
      Rule: 'Regel',
      ExplanationVideo: 'Erklärvideo',
      Exercise: 'Übung',
      Scorm: 'SCORM-Modul',
      Test: 'Test',
      ManualApproval: 'Manuelle Schulungsfreigabe',
      Survey: 'Umfrage',
      Signature: 'Unterschrift'
    };
    return typeLabels[type] || type;
  }

  getStatusAriaLabel(item: ExerciseVM) {
    if (item.finished) {
      return 'abgeschlossen';
    }
    if (!item.enabled) {
      return 'gesperrt';
    }
    if (item.hasSignature && !item.isSigned) {
      return 'Unterschrift erforderlich';
    }
    return 'nicht begonnen';
  }

  getManualApprovalAriaLabel() {
    const adminName = this.selectedExBundleAssignment?.finishedByAdminName || 'Unbekannt';
    const date = this.selectedExBundleAssignment?.finishedByAdminDate;
    return `Freigabe erteilt von ${adminName} ${date ? this.finishedDateToLocal(date.toString()) : ''}`;
  }

  get focusStyle() {
    return {
      '--focus-border-color': this.$store.state.ux.colorAccent,
      '--focus-bg-color': this.$store.state.ux.colorAccent + '20' // Add transparency
    };
  }
}
